import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, unref as _unref, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/login.jpg'
import _imports_1 from '../assets/logo.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-738b7c0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-page-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "login-img",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "logo-container" }, [
    /*#__PURE__*/_createElementVNode("img", {
      id: "pecsmart-logo",
      src: _imports_1
    })
  ])
], -1))
const _hoisted_3 = { class: "login-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%"} }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Login")
], -1))

import { useMainStore } from '@/store/main';
import { ref, Ref, onMounted, computed, ComputedRef } from "vue";
import router from '@/router';
import ResponseAlert from '@/components/ResponseAlert.vue';
import { useRegister } from '@/composables/form_behavior';

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

/* eslint-disable @typescript-eslint/no-explicit-any */
const { message, button_state_class, success, show_alert, showAlert, register } = useRegister()
const store = useMainStore()


// Methods
const login = async (event: any): Promise<void> => {
  try {
    await register(store.isUserAllowed, Object.fromEntries(new FormData(event.target)));

    router.push("/platform/dashboard");
  }
  catch(error) {
    console.log(error)
    return;
  }
}

// Data
const input_style: Ref<string> = ref("outline-color: var(--dark-green-pecsmart);")

//computed
const token : ComputedRef<string | null> = computed(()=>{
  return window.localStorage.getItem("Token")
})
onMounted(() => {
  if (token.value !== null) {
    router.push("/platform/dashboard");
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        onSubmit: _withModifiers(login, ["prevent"])
      }, [
        _hoisted_4,
        _createElementVNode("input", {
          style: _normalizeStyle(input_style.value),
          type: "text",
          name: "username",
          placeholder: "Nome de usuário",
          required: ""
        }, null, 4),
        _createElementVNode("input", {
          style: _normalizeStyle(input_style.value),
          type: "password",
          name: "password",
          placeholder: "Senha",
          required: ""
        }, null, 4),
        _createElementVNode("button", {
          class: _normalizeClass(_unref(button_state_class)),
          type: "submit"
        }, "Entrar", 2)
      ], 32)
    ]),
    _createVNode(ResponseAlert, {
      show: _unref(show_alert),
      onChangeShow: _unref(showAlert),
      success: _unref(success),
      message: _unref(message)
    }, null, 8, ["show", "onChangeShow", "success", "message"])
  ]))
}
}

})